<template>
  <CustomerSelectedStats />
</template>

<script>
import CustomerSelectedStats from "@/sections/lookupengine/components/Statistics/CustomerSelectedStats.vue";

export default {
  name: "CustomerSelectedView",
  components: {
    CustomerSelectedStats,
  },
};
</script>
